import { Link } from 'react-router-dom';
import SharedTrustBar from '../../components/feature/SharedTrustBar';
import SharedAIAnswerBlock from '../../components/feature/SharedAIAnswerBlock';
import SharedProcess from '../../components/feature/SharedProcess';
import SharedWhyChooseUs from '../../components/feature/SharedWhyChooseUs';
import SharedServiceAreaSection from '../../components/feature/SharedServiceAreaSection';
import SharedTestimonials from '../../components/feature/SharedTestimonials';
import SharedFAQ from '../../components/feature/SharedFAQ';
import SharedFinalCTA from '../../components/feature/SharedFinalCTA';

const COMPANY_OVERVIEW = [
  { icon: 'ri-heart-line', title: 'Our Mission', desc: 'To provide consistently excellent commercial cleaning that helps businesses maintain clean, safe, and professional environments — every single day across the Greater New Orleans area.' },
  { icon: 'ri-history-line', title: '20+ Years of Experience', desc: 'Since our founding, we have cleaned thousands of commercial spaces across Jefferson and Orleans Parish — from small professional offices to large federal government facilities.' },
  { icon: 'ri-award-line', title: 'Commitment to Quality', desc: 'GBAC certification, GSA federal contracts, BBB accreditation, and ongoing staff training reflect our relentless commitment to delivering the highest cleaning standards in Louisiana.' },
];

const CERTIFICATIONS = [
  'GSA Schedule Contractor #47QSHA22D0020',
  'MBE, 8a Graduated, DBE, HUD Section 3',
  'Advance Certified Custodial Technician',
  'Basic Certified Custodial Technician',
  'GBAC Certified — SARS-CoV-2/COVID-19',
  'Certificate of Achievement',
  'Victory Product Course Certified',
  'Victory Infection Course Certified',
  'LA Contractor License #71638',
];

const AI_ITEMS = [
  {
    question: 'Who is OJS Janitorial?',
    answer: 'OJS Janitorial is a professional commercial cleaning company based in Metairie, LA. Founded over 20 years ago, they deliver reliable, high-quality cleaning services for businesses across Greater New Orleans — from offices to federal government facilities.',
  },
  {
    question: 'What makes OJS Janitorial different from other cleaning companies?',
    answer: 'OJS Janitorial holds GSA federal contractor status, GBAC COVID-19 certification, BBB accreditation, and MBE certification. With over 20 years serving Louisiana businesses, they bring professional-grade expertise, trained staff, and a commitment to consistent quality on every visit.',
  },
  {
    question: 'What industries does OJS Janitorial serve?',
    answer: 'OJS Janitorial serves commercial offices, medical facilities, government buildings, retail spaces, educational facilities, and large commercial properties. They tailor every cleaning plan to match the specific standards, schedules, and needs of each industry and environment.',
  },
  {
    question: 'Is OJS Janitorial a certified, licensed cleaning company?',
    answer: 'Yes. OJS Janitorial holds LA Contractor License #71638, GSA Schedule federal contractor status, GBAC COVID-19 certification, MBE certification, and BBB accreditation — making them one of the most credentialed commercial cleaning companies in the Greater New Orleans area.',
  },
];

const WHY_BULLETS = [
  { icon: 'ri-shield-star-line', title: 'Fully Licensed & Insured', desc: 'Comprehensive liability insurance and LA Contractor License #71638 — providing full legal protection for every client facility.' },
  { icon: 'ri-government-line', title: 'GSA Federal Contractor', desc: 'One of only a select number of cleaning companies in Louisiana with active GSA Schedule federal contractor status.' },
  { icon: 'ri-team-line', title: 'Locally Owned & Operated', desc: 'Based in Metairie, LA — we\'re a local business that cares about our community and the businesses we serve every day.' },
  { icon: 'ri-award-line', title: 'Industry Certifications', desc: 'GBAC COVID-19 certified, BBB accredited, MBE certified, and trained in advanced custodial and infection control protocols.' },
  { icon: 'ri-shake-hands-line', title: 'Long-Term Partnerships', desc: 'We build lasting relationships — many clients have trusted OJS with their facilities for 10+ years of consistent service.' },
];

const FAQS = [
  {
    q: 'Why choose a professional janitorial company near me?',
    a: 'Hiring a professional janitorial company ensures consistent, high-quality cleaning using proper equipment and trained staff. It allows businesses to maintain a clean environment without managing in-house cleaning, saving time, reducing liability, and creating a healthier, more productive workplace for everyone.',
  },
  {
    q: 'How long has OJS Janitorial been in business?',
    a: 'OJS Janitorial has been serving commercial businesses in Metairie, New Orleans, and Greater Louisiana for over 20 years. During that time they have built a trusted reputation for reliability, professionalism, and consistent results across hundreds of commercial properties and facilities.',
  },
  {
    q: 'Is OJS Janitorial licensed, insured, and certified?',
    a: 'Yes, OJS Janitorial holds LA Contractor License #71638, is fully insured, GBAC COVID-19 certified, a GSA federal contractor, MBE certified, and BBB accredited. These credentials ensure clients receive professional, safe, and compliant cleaning services at all times.',
  },
  {
    q: 'What areas does OJS Janitorial serve?',
    a: 'OJS Janitorial serves businesses throughout Metairie, New Orleans, Kenner, Harahan, Jefferson Parish, Elmwood, Gretna, Westwego, and surrounding areas. Based in Metairie at 7809 Airline Drive, they provide fast, reliable commercial cleaning service across the entire Greater New Orleans metro area.',
  },
  {
    q: 'How do I get started with OJS Janitorial services?',
    a: 'Getting started is easy. Call (504) 818-3347 or fill out the online quote form. OJS Janitorial will schedule a free on-site walkthrough, assess your facility needs, and deliver a customized cleaning plan and quote within 24 hours. No commitment required to get your estimate.',
  },
];

const ABOUT_PROCESS = [
  { number: '01', icon: 'ri-lightbulb-line', title: 'Listen First', desc: 'We start by understanding your facility, standards, and expectations — not just taking an order.' },
  { number: '02', icon: 'ri-walk-line', title: 'On-Site Assessment', desc: 'Our team visits to see your space firsthand, identifying specific cleaning needs and opportunities.' },
  { number: '03', icon: 'ri-file-text-line', title: 'Custom Plan Created', desc: 'We build a detailed cleaning plan tailored to your industry, schedule, and exact requirements.' },
  { number: '04', icon: 'ri-team-line', title: 'Dedicated Crew Assigned', desc: 'You get consistent, trained staff — not random workers. The same crew that knows your facility.' },
  { number: '05', icon: 'ri-loop-right-line', title: 'Continuous Improvement', desc: 'We check in regularly, gather feedback, and refine our approach to keep exceeding your expectations.' },
];

export default function AboutPage() {
  return (
    <main>
      {/* Hero */}
      <section
        className="relative pt-32 pb-24 overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/cce76e13fcbc547a54b582d7362c4f9e.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-navy/97 via-navy/88 to-navy/60" />
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'linear-gradient(rgba(0,230,122,1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,230,122,1) 1px, transparent 1px)', backgroundSize: '80px 80px' }} />
        <div className="relative z-10 max-w-5xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 bg-accent/15 border border-accent/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-team-line text-accent text-sm"></i>
            <span className="text-accent text-xs font-body font-semibold uppercase tracking-widest">About Us</span>
          </div>
          <h1 className="font-heading font-extrabold text-white text-5xl xl:text-6xl mb-6 leading-tight max-w-3xl">
            About <span className="text-accent">OJS Janitorial</span> — Metairie&apos;s Trusted Commercial Cleaners
          </h1>
          <p className="text-white/65 font-body text-xl max-w-2xl mb-10 leading-relaxed">
            Locally owned and operated for over 20 years. Serving offices, commercial buildings, and federal facilities across Greater New Orleans with unmatched professionalism.
          </p>
          <Link to="/contact" className="bg-accent hover:bg-accent-dark text-navy font-heading font-extrabold px-9 py-4 rounded-full transition-all whitespace-nowrap inline-flex items-center gap-2">
            Work With Us <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* Trust Bar */}
      <SharedTrustBar />

      {/* Company Overview Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-start mb-20">
            {/* Left */}
            <div>
              <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
                <span className="text-accent text-xs font-body font-semibold uppercase tracking-wider">Our Story</span>
              </div>
              <h2 className="font-heading font-extrabold text-navy text-4xl xl:text-5xl mb-6 leading-tight">
                OJ&apos;s Janitorial &amp; Sweeping Service, LLC
              </h2>
              <p className="text-gray-500 font-body text-lg leading-relaxed mb-5">
                OJS Janitorial is a professional commercial cleaning company focused on delivering reliable, high-quality cleaning services for businesses throughout Metairie, New Orleans, and Greater Louisiana.
              </p>
              <p className="text-gray-500 font-body text-base leading-relaxed mb-8">
                From small professional offices to large commercial facilities and federal government buildings — we bring the same dedication, professionalism, and expertise to every job. Our slogan says it all: <em className="text-navy font-semibold">"We Shine and Clean All the Time."</em>
              </p>

              {/* Stats */}
              <div className="grid grid-cols-2 gap-4">
                {[
                  { value: '20+', label: 'Years in Business' },
                  { value: '500+', label: 'Businesses Served' },
                  { value: '9+', label: 'Certifications & Licenses' },
                  { value: '100%', label: 'Satisfaction Focus' },
                ].map((stat) => (
                  <div key={stat.label} className="bg-gray-50 rounded-xl p-5 border border-gray-100">
                    <div className="font-heading font-extrabold text-accent text-3xl">{stat.value}</div>
                    <div className="text-gray-500 font-body text-sm mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right */}
            <div className="flex flex-col gap-5">
              <div className="bg-navy rounded-2xl p-8 text-center">
                <img
                  src="https://ojsjanitorial.net/wp-content/uploads/2023/04/logo.png"
                  alt="OJ's Janitorial & Sweeping Service, LLC"
                  className="h-24 w-auto object-contain mx-auto mb-4"
                />
                <p className="text-white font-heading font-bold text-lg mb-1">OJ&apos;s Janitorial &amp; Sweeping Service, LLC</p>
                <p className="text-accent font-body text-sm italic mb-4">"We Shine and Clean All the Time"</p>
                <p className="text-white/40 font-body text-xs">Metairie, LA 70003 · (504) 818-3347</p>
              </div>
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
                <div className="flex items-center gap-3 mb-4">
                  <a href="https://www.bbb.org/us/la/metairie/profile/cleaning-services/ojs-janitorial-sweeping-service-llc-0985-90015985/" target="_blank" rel="nofollow noopener" className="cursor-pointer">
                    <img src="https://seal-neworleans.bbb.org/seals/blue-seal-150-110-bbb-90015985.png" alt="BBB Accredited Business" className="h-14 w-auto" />
                  </a>
                  <div>
                    <div className="font-heading font-bold text-navy text-sm">BBB Accredited Business</div>
                    <div className="text-gray-400 font-body text-xs">Better Business Bureau — New Orleans Chapter</div>
                  </div>
                </div>
              </div>
              {/* Image */}
              <div className="rounded-2xl overflow-hidden h-56">
                <img
                  src="https://readdy.ai/api/search-image?query=clean%20commercial%20office%20building%20exterior%20Metairie%20Louisiana%20modern%20corporate%20park%20blue%20sky%20professional%20business%20environment%20well%20maintained%20commercial%20property%20parking%20lot%20pristine%20landscaping&width=700&height=400&seq=about_bldg001&orientation=landscape"
                  alt="Commercial cleaning service in Metairie, LA"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Mission/Values */}
          <div className="grid md:grid-cols-3 gap-6">
            {COMPANY_OVERVIEW.map((val) => (
              <div key={val.title} className="bg-gray-50 rounded-2xl p-8 border border-gray-100 hover:border-accent/25 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-xl mb-5">
                  <i className={`${val.icon} text-accent text-xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-navy text-xl mb-3">{val.title}</h3>
                <p className="text-gray-500 font-body text-sm leading-relaxed">{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AI Answer Block */}
      <SharedAIAnswerBlock label="AI Answer Block — About OJS Janitorial" items={AI_ITEMS} />

      {/* Process */}
      <SharedProcess
        title="Our Company Philosophy in Action"
        subtitle="Every client relationship follows the same rigorous process — because consistent quality starts with consistent process."
        steps={ABOUT_PROCESS}
      />

      {/* Why Choose Us */}
      <SharedWhyChooseUs
        title="Why OJS Janitorial Is the Right Partner"
        subtitle="Credentials, consistency, and care. Two decades of trusted commercial cleaning serving Louisiana businesses."
        bullets={WHY_BULLETS}
        imageSrc="https://readdy.ai/api/search-image?query=professional%20commercial%20cleaning%20supervisor%20inspecting%20quality%20modern%20office%20building%20hallway%20clipboard%20uniform%20professional%20quality%20control%20management%20Louisiana%20commercial%20cleaning%20company%20inspection%20clean%20corporate%20building&width=800&height=900&seq=about_why001&orientation=portrait"
        imageAlt="OJS Janitorial quality inspection"
        ctaText="Partner With OJS Today"
      />

      {/* Service Areas */}
      <SharedServiceAreaSection
        title="Serving Businesses Across Greater New Orleans"
        subtitle="Based in Metairie — close enough to serve all of Jefferson Parish, Orleans Parish, and the surrounding metro area quickly and reliably."
      />

      {/* Testimonials */}
      <SharedTestimonials
        title="What Our Clients Say About OJS"
        subtitle="Long-term clients share why they trust OJS Janitorial with their most important commercial spaces."
      />

      {/* Certifications Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-accent text-xs font-body font-semibold uppercase tracking-wider">Credentials</span>
          </div>
          <h2 className="font-heading font-extrabold text-navy text-4xl mb-4">Certifications &amp; Licenses</h2>
          <p className="text-gray-500 font-body text-lg mb-10 max-w-xl mx-auto">Our credentials reflect our commitment to commercial cleaning excellence and industry-leading professional standards.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CERTIFICATIONS.map((cert) => (
              <div key={cert} className="flex items-start gap-3 bg-white border border-gray-100 rounded-xl px-5 py-4 text-left hover:border-accent/25 transition-colors">
                <i className="ri-checkbox-circle-fill text-accent mt-0.5 shrink-0 text-base"></i>
                <span className="text-navy font-body text-sm font-medium leading-snug">{cert}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <SharedFAQ title="About OJS Janitorial — Common Questions" faqs={FAQS} />

      {/* Final CTA */}
      <SharedFinalCTA
        title="Work With a Cleaning Company You Can Trust"
        subtitle="Get a free quote from Metairie's most credentialed commercial cleaning company. We respond within 24 hours."
        ctaButtonText="Request Your Free Quote"
        serviceLabel="Commercial Cleaning"
      />
    </main>
  );
}
